import useResponsive from '@/hooks/useResponsive';
import { Box, Stack, useTheme } from '@mui/material';
import Image from 'next/image';
import find from 'lodash/find';
import map from 'lodash/map';
import Typography from '../Typography';
import useGetCrypto from '@/hooks/useGetCrypto';
import Info from '../../../public/json/shitcoin/info.json';
import Button from '../Button';
import { Android } from 'iconsax-react';
import useLiveCrypto from '@/hooks/useLiveCrypto';

const ShitcoinHeroSection = () => {
  const { palette } = useTheme();
  const { matches } = useResponsive();

  const symbolFilter = [
    `${Info.header.base.toString().toUpperCase()}${Info.header.quote
      .toString()
      .toUpperCase()}`
  ];

  const source = Info.header.source as 'otc' | 'p2p';

  const { result } = useGetCrypto(
    {
      get: {
        side: source,
        filter: symbolFilter
      }
    },
    'getCurrentList',
    map(Info.list, item => `${item.base}${item.quote}`)
  );

  const Crypto = find(result || [], item => item.quote === Info.header.quote);
  const { message, isConnected } = useLiveCrypto({
    source,
    symbol: Crypto?.symbol || '',
    connect: true,
    pingPong: true
  });
  const priceChange = Number(
    (isConnected && !!message?.priceChange
      ? message.priceChange
      : Crypto?.[source]?.priceChange) || 0
  );
  return (
    <>
      <Stack
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        pt={{ xs: 4, lg: 9.5 }}
        mb={{ xs: 9, lg: 25.5 }}
        position="relative"
        zIndex={2}
      >
        <Stack flexDirection="row" alignItems="center" gap={3}>
          <Stack
            flexDirection="row"
            alignItems="center"
            gap={1.5}
            display={{ xs: 'none', lg: 'flex' }}
            bgcolor="#1D2126"
            borderRadius={8}
            boxShadow="0px 4px 0px rgb(0 0 0 / 25%)"
            py={2.5}
            px={3}
          >
            <Box
              width={6}
              height={6}
              bgcolor={palette.success.A100}
              borderRadius={10}
              boxShadow={`0 0 10px ${palette.success.A100}`}
              m={2.5}
            />
            <Typography color="textColor.A40" variant="body2" mr={1}>
              رمزارز روز
            </Typography>
          </Stack>
          <Stack flexDirection="row" alignItems="center" gap={2}>
            <Image
              priority
              src={Crypto?.logoUrl || ''}
              width={matches({ xs: 16, lg: 24 })}
              height={matches({ xs: 16, lg: 24 })}
              style={{ borderRadius: '50%' }}
              alt="logo"
            />
            <Typography
              color="textColor.A10"
              variant={matches({ xs: 'body4', lg: 'body2' })}
            >
              {Crypto?.baseFa || '-'}
            </Typography>
            <Typography color="textColor.A10" variant="body2" mx={-1}>
              .
            </Typography>
            <Typography
              color={priceChange >= 0 ? 'success.A100' : 'error.A100'}
              variant="body3"
              mt={1}
            >
              (%{priceChange || '-'})
            </Typography>
          </Stack>
        </Stack>
        <Image
          priority
          src="/assets/shitcoin/logotype_rabex.svg"
          width={matches({ xs: 92, lg: 156 })}
          height={matches({ xs: 28, lg: 48 })}
          alt="logo"
        />
      </Stack>
      <Stack
        gap={2}
        alignItems={{ xs: 'center', lg: 'start' }}
        mb={{ xs: 6, lg: 27 }}
        position="relative"
        zIndex={2}
      >
        <Typography
          variant={matches({ xs: 'h4', lg: 'h2' })}
          component="p"
          color="textColor.A30"
          weight="bolder"
          mb={{ xs: 0, lg: 1 }}
        >
          رمزارزهای مستعد انفجــار
        </Typography>
        <Typography
          variant={matches({ xs: 'body2', lg: 'body1' })}
          component="p"
          color="textColor.A20"
          weight="bold"
          mb={{ xs: 14.5, lg: 8 }}
        >
          در رابکس ۱۰۰۰+ ارز دیجیتال مستعد انفجار رو معامله کن ...
        </Typography>
        <Stack
          flexDirection="row"
          alignItems="center"
          gap={{ xs: 6, lg: 2.5 }}
          flexWrap="nowrap"
        >
          <a href="https://p.rabex.ir/auth/register">
            <Button
              size="small"
              color="primary"
              sx={{ width: matches({ xs: 146, lg: 120 }) }}
            >
              ثبت نام
            </Button>
          </a>
          <a href="https://rabex.ir/download/">
            <Button
              size="small"
              color="secondary"
              sx={{
                background: '#636C7F',
                '&:hover': { background: '#b4b8bc' },
                color: '#fff',
                width: matches({ xs: 168, lg: 159 })
              }}
              startIcon={<Android size={24} variant="Bold" />}
            >
              نسخه اندروید
            </Button>
          </a>
        </Stack>
      </Stack>
      {matches({
        xs: (
          <Stack
            position="absolute"
            top={65}
            alignItems="center"
            width="100%"
            zIndex={1}
          >
            <Image
              src="/assets/shitcoin/hero_responsive.png"
              width={376}
              height={241}
              alt=""
            />
          </Stack>
        ),
        lg: (
          <Stack position="absolute" top={0} right={-152} zIndex={1}>
            <Image
              src="/assets/shitcoin/hero_desktop.png"
              width={929}
              height={531}
              alt=""
            />
          </Stack>
        )
      })}
    </>
  );
};

export default ShitcoinHeroSection;
